import { Socket } from 'types/socket'
import { logSocketDebug } from '../../utils/logger'

let socketClient: Socket | null = null

export const connectSockets = () => {
  if (!window.isSocketConnectionTriggered && window.subscribeToSockets) {
    // window.isSocketConnectionTriggered = true
    socketClient = window.subscribeToSockets()
    socketClient?.on('event', data => {
      logSocketDebug(`${data.socketType || data.type}`, data)
    })
  }
}

export const disconnectSockets = () => {
  if (window.isSocketConnectionTriggered && window.disconnectSockets) {
    window.isSocketConnectionTriggered = false
    window.disconnectSockets()
    socketClient = null
  }
}

type TEventListener<T> = (data: T) => unknown

export const setSocketListener = <T>(listener: TEventListener<T>) => {
  socketClient?.on('event', listener)
}

export const removeSocketListener = <T>(listener: TEventListener<T>) => {
  socketClient?.off('event', listener)
}
